import React, { memo, useEffect, useLayoutEffect, useState } from 'react'
import { useFocusable } from '@noriginmedia/norigin-spatial-navigation'
import classNames from 'classnames'

import playLogo from '../../assets/img/epg_play_logo.svg'

import type { ChannelProps } from './types'
import type {
  FocusDetails,
  FocusableComponentLayout,
} from '@noriginmedia/norigin-spatial-navigation'

const Channel = ({
  data,
  index,
  onFocus,
  onEnterPress,
  hasFocusedChild,
  hasHiddenListingAtStart,
  autoFocus,
  setAutoFocusEPG,
  focusKey,
}: ChannelProps) => {
  const [wasFocused, setWasFocused] = useState(false)
  const { ref, focused, focusSelf } = useFocusable({
    onFocus,
    onEnterPress,
    extraProps: { index, channel: data, focusedOnListingsGrid: false },
    focusKey,
  })

  useLayoutEffect(() => {
    if (!wasFocused && !focused && hasFocusedChild) {
      onFocus(
        {} as FocusableComponentLayout,
        { index, channel: data, focusedOnListingsGrid: true },
        {} as FocusDetails
      )
    }
    setWasFocused(focused)
  }, [focused, hasFocusedChild])

  useEffect(() => {
    if (autoFocus && index === 0) {
      console.log('Channel: autoFocus')
      focusSelf()
      setAutoFocusEPG(false)
    }
  }, [autoFocus, focusSelf, setAutoFocusEPG])

  return (
    <div
      className={classNames('epg__channel', {
        'epg__channel--focused': hasFocusedChild,
        'epg__channel--with-hidden-listing-at-start': hasHiddenListingAtStart,
      })}
      ref={ref}
    >
      <div
        className="epg__channel-overlay-focused"
        style={{ visibility: focused ? 'visible' : 'hidden' }}
      >
        <p>
          <span>
            <img className="epg__play-focused-logo" src={playLogo} />
          </span>
          <span>Watch Channel</span>
        </p>
      </div>
      <div className="epg__channel-image-container">
        {data?.feed_image?.white_logo ? (
          <img
            className="epg__channel-image"
            src={`${data.feed_image.white_logo}?format=webp&resize=250x56`}
            alt={data.full_name}
          />
        ) : (
          <div className="epg__channel-logo-content">
            <p className="epg__channel-logo-content--text">{data?.full_name}</p>
          </div>
        )}
      </div>
    </div>
  )
}

export default memo(Channel)
